import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { clearNavigationWarnings } from "./useNavigationWarning";

/**
 * Custom hook to handle navigation after verification
 * @param {Function} [customNav] - Optional custom navigation function (url, state) => void
 * @returns {Function} A function that takes (state, success_page_display, forceNavigate)
 */
const useVerifiedNavigation = (customNav) => {
  const navigate = useNavigate();

  return useCallback(
    (state, success_page_display, forceNavigate = false) => {
      if (success_page_display || forceNavigate) {
        // Clear warnings before internal navigation too, to be safe
        clearNavigationWarnings(() => {
          if (customNav) {
            customNav("/verified", state);
          } else {
            navigate("/verified", { state });
          }
        });
      } else if (state?.url) {
        // Clear warnings before redirecting to an external URL
        clearNavigationWarnings(() => {
          window.location.href = state.url;
        });
      }
    },
    [navigate, customNav]
  );
};

export default useVerifiedNavigation;
